import React, { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';

import { mapSelectOptions } from '../../helpers/utilities';
import { capitalize } from '../../helpers/formatters';
import { MainContext } from '../../store/contexts';
import { Icon } from '../common/ui/Icon';

export const ProductForm = ({ model: product = {}, mode = 'show', onSubmit, onReset }) => {
    const defaultCategories =
        product && product.categories ? mapSelectOptions(product.categories) : [];

    const defaultValues = {
        ...product,
        categories: defaultCategories
    };

    const {
        formState: { errors },
        handleSubmit,
        register,
        control,
        watch
    } = useForm({
        defaultValues
    });

    const [icon] = watch(['icon']);
    const { categories } = useContext(MainContext);
    const categoryOptions = mapSelectOptions(categories);

    const validations = {
        icon: {
            required: 'Icon is required.',
            minLength: {
                value: 3,
                message: 'Icon must be at least 6 characters long.'
            }
        },
        name: {
            required: 'Name is required.',
            minLength: {
                value: 3,
                message: 'Name must be at least 6 characters long.'
            }
        },
        price: {
            required: 'Price is required.'
        }
    };

    const handleBeforeSubmit = (form) => {
        onSubmit({
            ...form,
            categories: form.categories != null ? form.categories.map((item) => item.value) : []
        });
    };

    return (
        <form
            className="product-form"
            onSubmit={handleSubmit(handleBeforeSubmit)}
            onReset={onReset}>
            <div className="row">
                <div className="col-12 d-flex justify-content-center align-items-center">
                    <Icon icon={icon} size="5x"></Icon>
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="productIcon" className="form-label">
                        Icon
                    </label>
                    <input
                        {...register('icon', validations.icon)}
                        type="text"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.icon ? 'is-invalid' : ''}`}
                        id="productIcon"
                    />
                    {errors.icon && (
                        <div className="invalid-feedback d-block">{errors.icon.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="productCategories" className="form-label">
                        Categories
                    </label>
                    <Controller
                        control={control}
                        name="categories"
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { invalid, isTouched, isDirty, error },
                            formState
                        }) => (
                            <Select
                                isLoading={categories.isLoading}
                                isDisabled={mode === 'show'}
                                classNamePrefix="react-select"
                                options={categoryOptions}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                name={name}
                                ref={ref}
                                isMulti
                            />
                        )}
                    />
                    {errors.categories && (
                        <div className="invalid-feedback d-block">{errors.categories.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="ProductName" className="form-label">
                        Name
                    </label>
                    <input
                        {...register('name', validations.name)}
                        type="text"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        id="ProductName"
                    />
                    {errors.name && (
                        <div className="invalid-feedback d-block">{errors.name.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="ProductPrice" className="form-label">
                        Price
                    </label>
                    <input
                        {...register('price', validations.price)}
                        type="number"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                        id="ProductPrice"
                    />
                    {errors.price && (
                        <div className="invalid-feedback d-block">{errors.price.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="productDescription" className="form-label">
                        Description
                    </label>
                    <textarea
                        {...register('description')}
                        readOnly={mode == 'show'}
                        className="form-control"
                        id="productDescription"
                        rows="6"
                    />
                </div>
            </div>
            {mode === 'show' && (
                <div className="d-grid col-sm-6 col-md-4 col-lg-3">
                    <button onClick={onReset} type="button" className="btn btn-outline-secondary">
                        Close
                    </button>
                </div>
            )}
            {mode !== 'show' && (
                <div className="row my-3">
                    <div className="d-grid order-1 order-sm-0 col-sm-6 col-md-4 col-lg-3 mb-3 mb-sm-0">
                        <button className="btn btn-outline-secondary" type="reset">
                            Cancel
                        </button>
                    </div>
                    <div className="d-grid order-0 order-sm-1 col-sm-6 col-md-4 col-lg-3 offset-md-4 offset-lg-6 mb-3 mb-sm-0">
                        <button className="btn btn-primary" type="submit">
                            {capitalize(mode)}
                        </button>
                    </div>
                </div>
            )}
        </form>
    );
};
